import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import KnowledgePage from "./pages/knowledge";
import KnowledgeDetailsPage from "./pages/knowledgeDetails";
import VideoPage from "./pages/videoPlayer";
import CalendarPage from "./pages/calendar";

import LoginPage from "./pages/login";
import VNIChartPage from "./pages/chart";
// import StatisticsPage from "./pages/statistics";
// import MatchesPage from "./pages/matches";
// import MatchDetailPage from "./pages/matchDetails";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/knowledge" element={<KnowledgePage />} />
                <Route path="/knowledge/:id" element={<KnowledgeDetailsPage />} />
                <Route path="/videoplayer" element={<VideoPage />} />
                <Route path="/economicdata" element={<VideoPage />} />
                <Route path="/news" element={<VideoPage />} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/chart" element={<VNIChartPage />} />
                <Route path="/chart/:symbol" element={<VNIChartPage />} />
                {/* <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/matches" element={<MatchesPage />} />
                <Route path="/match/:id" element={<MatchDetailPage />} /> */}

                <Route path="*" element={<Navigate to="/knowledge" />} />
            </Routes>
        </Router>
    );
};

export default App;
 